import { motion, AnimatePresence } from 'framer-motion';
import BeerCard from './BeerCard';

export default function BeerList() {
  const isSmallScreen = window.innerWidth < 768; // Tailwind's `md` breakpoint
  const viewportAmount = isSmallScreen ? 0.2 : 0.7;
  return (
    <div className='relative flex flex-col items-center'>
      <AnimatePresence mode='sync'>
        <motion.div
          key='djeneral'
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50, transition: { duration: 0.5 } }} // Moves up & disappears
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: false, amount: viewportAmount }}
          style={{ willChange: 'transform, opacity' }}
        >
          <BeerCard type={'djeneral'} />
        </motion.div>

        <motion.div
          key='tango'
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50, transition: { duration: 0.5 } }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.3 }} // Delays appearance slightly
          viewport={{ once: false, amount: viewportAmount }}
          style={{ willChange: 'transform, opacity' }}
        >
          <BeerCard type={'tango'} />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
